import Icon from "rc-app/components/Icons";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const AgentHomePage: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const base = slug ? `/c/${slug}` : "";

  const menuItems = [
    {
      title: "Projects",
      icon: "ic-client-projects",
      path: `${base}/p/library`,
    },
    {
      title: "Leads",
      icon: "ic-client-customers",
      path: `${base}/leads`,
    },
    {
      title: "Analytics",
      icon: "ic-client-analytics",
      path: `${base}/analytics`,
    },
    {
      title: "Profile",
      icon: "ic-client-profile",
      path: `${base}/profile`,
    },
  ];

  return (
    <div className="min-h-[calc(100dvh-64px)] bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] flex flex-col">
      {/* Hero Section */}
      <div className="flex-shrink-0 flex flex-col md:flex-row px-4 py-6 md:h-[300px] bg-[#222F3C] items-center justify-between">
        <div className="flex flex-col w-full md:w-1/2 justify-center gap-4">
          <div className="flex flex-col">
            <h1 className="text-white text-2xl md:text-4xl font-bold mb-2 md:mb-4 leading-tight">
              HELPING YOU CUSTOMERS <br />
              INVEST IN THEIR FUTURE HOME{" "}
            </h1>
            <p className="text-white/90 text-sm md:text-lg">
              The one stop place to manage your profile.{" "}
            </p>
          </div>
        </div>

        {/* static image */}
        <div className="hidden md:block h-full w-1/2 rounded-t-lg">
          <img
            src={`${process.env.REACT_APP_UPLOADED_URL}/realestate/agentHomeImage.jpg`}
            alt="Buildings"
            className="w-full h-full object-cover overflow-hidden rounded-t-lg"
          />
        </div>
      </div>

      {/* Menu Cards */}
      <div className="flex-1 min-h-0 container mx-auto px-4 py-5 md:py-3 md:px-8 flex items-start md:items-center">
        {/* Centered flex: tiles keep the same 6-up width as the ABA/ASA home
            so the agent's 4 sit centered at an identical size, not stretched. */}
        <div className="w-full flex flex-wrap justify-center gap-3 md:gap-6">
          {menuItems.map((item) => (
            <div
              key={item.title}
              onClick={() => navigate(item.path)}
              className="grow-0 shrink-0 basis-[calc((100%_-_0.75rem)/2)] md:basis-[calc((100%_-_3rem)/3)] lg:basis-[calc((100%_-_7.5rem)/6)] border-2 border-[#FFFFFF] rounded-2xl p-3 md:p-5 cursor-pointer hover:bg-[#254555] transition-all flex flex-col items-center justify-center"
            >
              <div className="w-12 h-12 md:w-24 md:h-24 mb-1.5 md:mb-3">
                <Icon name={item.icon} className="w-full h-full" />
              </div>
              <h3 className="text-white text-sm md:text-lg font-medium text-center">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgentHomePage;
